import { KTSVG } from "../../../../_start/helpers";
import { IQuotationActivityLog } from "../models/QuotationActivityLog";
import { SystemLog } from "./SystemLog";
import { UserLog } from "./UserLog";

type QuotationActivityLogModalProps = {
	logs: Array<IQuotationActivityLog>;
};

export const QuotationActivityLogModal = ({
	logs,
}: QuotationActivityLogModalProps) => {
	return (
		<div className="modal fade" tabIndex={-1} id="activity_log_modal">
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">Activity Log</h5>
						<div
							className="btn btn-icon btn-sm btn-active-light-primary ms-2"
							data-bs-dismiss="modal"
							aria-label="Close"
						>
							<KTSVG
								path="/media/icons/duotone/Navigation/Close.svg"
								className="svg-icon svg-icon-2x"
							/>
						</div>
					</div>
					<div className="modal-body">
						{logs
							.filter((item) => item.attributes !== undefined)
							.map((item, idx) => {
							if (item.attributes.causer === "SYSTEM") {
								return (
									<SystemLog key={idx} log={item} />
								);
							}

							return <UserLog key={idx} log={item} />;
						})}
					</div>
					<div className="modal-footer">
						<button
							type="button"
							className="btn btn-light"
							data-bs-dismiss="modal"
						>
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
